import { useState } from 'react';
import ImageBox from '../../components/shareable/imageBox';
import { InputArea } from '../../components/shareable/input';
import FooterNote from '../../components/shareable/footerNote';
import logo from '../../assets/images/image.png';
import { post } from '../../api/api';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

const Login = () => {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();
  const handleForgot = async () => {
    try {
      const res = await post(`/forgot-password`, { email });

      if (res?.message) {
        toast.success("New password in sent on the email");
        navigate('/home');
      } else {
        toast.error('Something went wrong. Please try again.');
      }
    } catch (e) {
      console.log(e);
      toast.error('Server error. Please try again later.');
    }
  };
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white">
      <div className="bg-gray-100 p-8 rounded-lg shadow-md w-full max-w-sm">
        <ImageBox
          src={logo}
          alt="App Logo"
          border={false}
          className="flex justify-center"
        />
        <hr className="my-4 border-gray-400" />

        {/* {error && (
          <div className="mb-4 p-2 bg-red-100 text-red-700 rounded">
            Your email or Password is incorrect 
          </div>
        )} */}

        <form
          className="space-y-4"
          onSubmit={(e) => {
            e.preventDefault();
            handleForgot();
          }}
        >
          <InputArea
            type="email"
            placeholder="Input Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button
            type="submit"
            className="bg-red-600 text-white px-4 py-2 rounded w-full mt-4"
          >
            Confirm
          </button>
        </form>
      </div>
      <FooterNote text="Bad Ass Band Saws Quoting System v0.01" />
    </div>
  );
};

export default Login;